<template>
  <RF-Dialog
  :cpntStatus='statusGeral'
  :cpntLargura='"600px"'
  :cpntOnFecharDialog='cpntFecharFormulario'>
    <template slot='titulo' v-if="[ '', null, undefined ].indexOf(dados) === -1">
      <div class="dem-pro-doc-pgto-dialog">
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        NF com pagamentos?

        <App-Toggles :data-time="time" class="app-cpnt-field" :class="campos.informar.id" v-if="(dados.p_doc_tp === 'NFe' && dados.nfEmitida === false)"
          :cpntStatus='campos.informar.status'
          :cpntId='campos.informar.id'
          :cpntClassDivField='campos.informar.classDivField'
          :cpntNome='campos.informar.nome'
          :cpntValue='campos.informar.value'
          :cpntDisabled='campos.informar.disabled'
          :cpntMostrar='campos.informar.mostrar'
          :cpntMensagem='campos.informar.mensagem'
          :cpntMensagemTipo='campos.informar.mensagemTipo'
          :cpntOn='campos.informar.on'
          :cpntOff='campos.informar.off'
          :cpntExplica='campos.informar.explica'
          :cpntWidth='campos.informar.width'
          :cpntTabIndex='campos.informar.tabIndex'

          :cpntOnChange='campos.informar.onChange'
          :cpntOnBlur='campos.informar.onBlur'
          ref='informar'
        ></App-Toggles>

        <span v-else v-html="campos.informar.value === true ? 'Sim' : 'Não'"></span>
      </div>
    </template>

    <template slot='conteudo' v-if="statusGeral === ''">
      <Demanda-Editar-Produtos-Documento-Pagamento :data-time="time"
      :cpntDemanda="cpntDemanda"
      :cpntDemandaId="cpntDemandaId"
      :cpntFecharFormulario="cpntFecharFormulario"
      @SETAR_DADOS_DIALOG_PGTO="demEdiProDocDialogPagSetarDados"
      ref="pgto"
      ></Demanda-Editar-Produtos-Documento-Pagamento>
    </template>
  </RF-Dialog>
</template>

<style scoped>
</style>

<style>
.dem-pro-doc-pgto-dialog > .cpnt-app-toggle {
  width: 100px;
  vertical-align: 0px;
}
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      // cpntDemandaTotal: {
      //   required: true
      // },
      // cpntDemData: {
      //   required: true
      // },
      // cpntPDocAcoes: {
      //   required: true
      // },
      // cpntPDocFiscal: {
      //   required: true
      // },
      // cpntPDocNFEmitida: {
      //   required: true
      // },
      // cpntPDocTp: {
      //   required: true
      // },
      // cpntPDocDocs: {
      //   required: true
      // },

      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'Demanda-Editar-Produtos-Documento-Pagamento': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Documento-Pagamento.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        aba: '',
        valores: {},
        campos: {
          informar: {
            id: 'dem-edi-pro-doc-dialog-pag--informar',
            status: '',
            nome: '',
            value: true,
            salvo: '',
            onChange: this.demEdiProDocPagOnChangeValue
          }
        },
        dados: null
      }
    },
    methods: {
      demEdiProDocPagOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 'informar':
            this.$refs.pgto.demEdiProDocPagOnChangeValue(value, id)
            break
        } 
      },
      demEdiProDocDialogPagSetarDados: function (vetor) {
        setTimeout(() => {
          // SETA O VALOR INICIAL DO CAMPO
          this.campos.informar.value = this.$refs.pgto.campos.informar.value

          // SETA OS DADOS RECEBIDOS
          this.dados = vetor

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, 500)
      }
    }
  }
</script>
